import { call, put, takeLatest } from 'redux-saga/effects';

import { removeCertificate } from '../../services/API';
import { actionTypes, requestFailure, requestSuccess } from './actions';

function* getData(action) {
  const response = yield call(removeCertificate, action.payload);
  yield put(response.isOk ? requestSuccess({ status: 'OK' }) : requestFailure(response.error));
}

export default function* removeCertificateSaga() {
  yield takeLatest(actionTypes.REQUEST_START, getData);
}
